const appearanceMap = {
    resolved: 'success',
    rejected: 'secondary',
    critical: 'danger',
    notable: 'warning',
    minor: 'warning',
};
export const getFeedbackChipAppearance = (type) => appearanceMap[type];
